import request from '@/utils/request'
const apiPath = '/order/tuitionOrder'
import { downloadBlob } from '@/utils/download'
const rechargeRecordApi = {
  /**
   * 新增【订单】
   */
  create(data) {
    return request.post(apiPath + '/RechargeToManage', data)
  },
  /**
   * 分页查询【订单】
   */
  fetchList(query) {
    return request.get(apiPath + '/findListToManage', { params: query })
  },
  /**
   * 识别支付凭证【订单】
   */
  accurateOCR(data) {
    return request.post(apiPath + '/generalAccurateOCR', data)
  },
  /**
   * 导出【订单】
   */
  tuitionListExport(query) {
    return request.get(apiPath + '/tuitionListExport', { params: query })
  },
  allPaymentExport(query) {
    return request.get(apiPath + '/allPaymentExport', { params: query })
  },
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },

}
export default rechargeRecordApi